
//copyright: Big Screen Entertainment Group Inc.
export const SET_CUSTOM_1 = 'SET_CUSTOM_1';

export function setCustom1(playlist) {
  return {
    type: SET_CUSTOM_1,
    playlist,
  };
}